import type { CSSProperties } from 'react'
import { Checklist } from '../Checklist'
import { useKitchensink } from '../context'
import { theme } from '../theme'

const cardStyle: CSSProperties = {
  backgroundColor: theme.surface,
  border: `1px solid ${theme.border}`,
  borderRadius: '10px',
  padding: '20px 24px',
  marginBottom: '16px',
}

const sectionTitleStyle: CSSProperties = {
  fontSize: '11px',
  fontWeight: 700,
  color: theme.textMuted,
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  margin: '0 0 12px',
}

const stepStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '12px',
  marginBottom: '12px',
}

const stepNumStyle: CSSProperties = {
  flexShrink: 0,
  width: '22px',
  height: '22px',
  borderRadius: '50%',
  backgroundColor: theme.accentSubtle,
  border: `1px solid ${theme.accent}`,
  color: theme.accent,
  fontSize: '11px',
  fontWeight: 700,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '1px',
}

const stepTextStyle: CSSProperties = {
  fontSize: '13px',
  color: theme.textMuted,
  lineHeight: '1.55',
}

const chipStyle: CSSProperties = {
  display: 'inline-block',
  backgroundColor: theme.accentSubtle,
  color: theme.accent,
  fontSize: '12px',
  fontWeight: 600,
  padding: '2px 8px',
  borderRadius: '4px',
}

export const HomePage = () => {
  const { variant } = useKitchensink()

  return (
    <div>
      <h1
        style={{
          fontSize: '24px',
          fontWeight: 700,
          color: theme.text,
          margin: '0 0 6px',
          letterSpacing: '-0.02em',
        }}
      >
        🍽️ Welcome to the Kitchen
      </h1>
      <p style={{ fontSize: '13px', color: theme.textMuted, margin: '0 0 28px' }}>
        Web Data snippet playground — mise en place before the rush.
      </p>

      <div style={cardStyle}>
        <p style={sectionTitleStyle}>How to use</p>
        <div style={stepStyle}>
          <span style={stepNumStyle}>1</span>
          <p style={stepTextStyle}>
            Enter your <span style={chipStyle}>tenantSubdomain</span> and{' '}
            <span style={chipStyle}>tenantId</span> in the config bar above, and pick the{' '}
            <span style={chipStyle}>environment</span> the snippet should load from. They're stored
            in the URL so you can bookmark or share your setup.
          </p>
        </div>
        <div style={stepStyle}>
          <span style={stepNumStyle}>2</span>
          <p style={stepTextStyle}>
            Hit <strong style={{ color: theme.accent }}>🔥 Initialize</strong> to fire up the
            snippet — or tick <strong style={{ color: theme.text }}>Auto-init on page load</strong>{' '}
            to initialize on every load like a real customer site.
          </p>
        </div>
        <div style={stepStyle}>
          <span style={stepNumStyle}>3</span>
          <p style={{ ...stepTextStyle, marginBottom: 0 }}>
            Navigate to <strong style={{ color: theme.text }}>Page A</strong> and{' '}
            <strong style={{ color: theme.text }}>Page B</strong> to test how the snippet reacts to{' '}
            {variant === 'spa' ? 'SPA route changes' : 'full page loads'}, then verify the network
            calls below.
          </p>
        </div>
      </div>

      <div style={{ ...cardStyle, marginBottom: '16px' }}>
        <p style={sectionTitleStyle}>Mock data</p>
        <p style={{ ...stepTextStyle, margin: 0 }}>
          The page sets <span style={chipStyle}>_6senseCompanyDetails</span> in localStorage after a
          2s delay — simulating a 6sense visitor detection event mid-session.
        </p>
      </div>

      <Checklist />
    </div>
  )
}
